/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { encodeBase64 } from '../../utils/utilityFunctions';
import { CALL_API } from '../middleware';
import {
  InvestorSignUpPayload,
  InvestorVerificationResponse,
  LoginWithOtpRequestBody,
  LoginWithOtpResponseBody,
  VerifyLoginOtpRequestBody,
  VerifyLoginOtpResponseBody,
} from '../types/api-types';
import {
  LOGIN_WITH_OTP,
  LOGIN_WITH_OTP_SUCCESS,
  LOGOUT_SUCCESS,
  VERIFY_LOGIN_OTP,
  VERIFY_LOGIN_OTP_SUCCESS,
  GET_USER_INFO_SUCCESS,
  GET_USER_INFO,
  SHOW_GLOBAL_ERROR,
  LOGOUT,
  INVESTOR_SIGNUP_SUCCESS,
  INVESTOR_SIGNUP,
} from '../types/auth';

export const loginWithOtp =
  (body: LoginWithOtpRequestBody) =>
  async (dispatch: any): Promise<LoginWithOtpResponseBody> => {
    console.log(body, 'body in login with otp');
    return await dispatch({
      [CALL_API]: {
        url: `/users/login/send-otp`,
        method: 'POST',
        types: [LOGIN_WITH_OTP_SUCCESS, LOGIN_WITH_OTP],
        body: { payload: encodeBase64(JSON.stringify(body)) },
      },
    });
  };

export const verifyLoginOtp =
  (body: VerifyLoginOtpRequestBody) =>
  async (dispatch: any): Promise<VerifyLoginOtpResponseBody> => {
    console.log(body, 'body in verify login otp');
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/login/verify-otp`,
        method: 'POST',
        types: [VERIFY_LOGIN_OTP_SUCCESS, VERIFY_LOGIN_OTP],
        body: { payload: encodeBase64(JSON.stringify(body)) },
      },
    });
  };

export const logout = () => {
  return {
    [CALL_API]: {
      url: `/users/users/logout`,
      method: 'POST',
      types: [LOGOUT_SUCCESS, LOGOUT],
    },
  };
};
export const getArnCode =
  () =>
  async (dispatch: any): Promise<InvestorVerificationResponse> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/esign/getArnLink`,
        method: 'GET',
        types: ['GET_ARN_CODE_SUCCESS', 'GET_ARN_CODE'],
      },
    });
  };

export const getUserInfo = () => {
  return {
    [CALL_API]: {
      url: `/users/users/me`,
      method: 'GET',
      types: [GET_USER_INFO_SUCCESS, GET_USER_INFO],
    },
  };
};

export const showError = (message: string) => {
  return {
    type: SHOW_GLOBAL_ERROR,
    errorType: 'ALERT',
    message,
  };
};

export const investorSignUpApi =
  (body: InvestorSignUpPayload) =>
  async (dispatch: any): Promise<InvestorVerificationResponse> => {
    return await dispatch({
      [CALL_API]: {
        url: `/users/register/signup`,
        method: 'POST',
        types: [INVESTOR_SIGNUP_SUCCESS, INVESTOR_SIGNUP],
        // body: { payload: encodeBase64(JSON.stringify(body)) },
        body,
      },
    });
  };
